export const contactGroupsListReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONTACT_GROUPS":
      return action.payload;
    case "NEW_CONTACT_GROUP":
      return state.concat(action.payload);
    case "DELETE_CONTACT_GROUP":
      return state.filter(contactGroup => {
        return contactGroup.email_list_id !== action.payload;
      });
    case "UPDATE_CONTACT_GROUP": 
      return state.map(contactGroup => {
        if(contactGroup.email_list_id === action.payload.email_list_id){
            return action.payload;
        }else{
          return contactGroup;
        }
      });
    default:
      return state;
  }
};

export const editContactsReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_EDIT_CONTACT_MODAL":
      return { ...state, editing: !state.editing };
    case "SET_EDITING_CONTACT_ID":
      return { ...state, contactId: action.payload };

    default:
      return state;
  }
};
export const editGroupsReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_EDIT_GROUP_MODAL":
      return { ...state, editing: !state.editing };
    case "SET_EDITING_GROUP_ID":
      return { ...state, groupId: action.payload };

    default:
      return state;
  }
};

export const allContactsReducer = (state, action) => {
  switch (action.type) {
    case "SET_ALL_CONTACTS_LIST":
      return action.payload;
    default:
      return state;
  }
};

export const entireListOfContactsReducer = (state, action) => {
  switch (action.type) {
    case "SET_ENTIRE_LIST_OF_CONTACTS":
      return action.payload;
    case "ADD_CONTACT_TO_ENTIRE_LIST":
      action.payload.full_name = action.payload.first_name + " " + action.payload.last_name
      return [...state, action.payload]
    case "UPDATE_CONTACT":
      return [...state.map(contact => {
        if (contact.contact_id === action.payload.contact_id ){
          return action.payload
        }else{
          return contact
        }
      })]
    default:
      return state;
  }
};

export const unsubscribesReducer = (state, action) => {
  switch (action.type) { 
    case "SET_UNSUBSCRIBES":
      return action.payload;
    default:
      return state;
  }
};
export const orderByReducer = (state, action) => {
  switch (action.type) { 
    case "SET_ORDERBY":
      return action.payload;
    default:
      return state;
  }
};
export const sortByReducer = (state, action) => {
  switch (action.type) { 
    case "SET_SORTBY":
      return action.payload;
    default:
      return state;
  }
};

export const countReducer = (state, action) => {
  switch (action.type) { 
    case "SET_MAX":
      return action.payload;
    default:
      return state;
  }
};

export const contactsListReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONTACTS_FOR_ACTIVE_GROUP":
      return {
        original: action.payload,
        filtered: action.payload
      };
    case "UPDATE_CONTACT":
      return {
        original: state.original.map(contact => {
          if (contact.id === action.payload.id) {
            if(!action.payload.remove){
              return action.payload;
            }else{
              // console.log("removing")
            }
          } else {
            return contact;
          }
        }),
        filtered: state.filtered.map(contact => {
          if (contact.id === action.payload.id) {
            if(!action.payload.remove){
              return action.payload;
            }
          } else {
            return contact;
          }
        })
      };
    case "UPDATE_CONTACTS":
    let ids = action.payload.map(update => update.contact_id)
    state.original.forEach((contact, i) => {
      if (ids.indexOf(contact.contact_id) > -1) {
        state.original[i] = action.payload[ids.indexOf(contact.contact_id)];
      } 
    })
    state.filtered.forEach((contact, i) => {
      if (ids.indexOf(contact.contact_id) > -1) {
        state.original[i] = action.payload[ids.indexOf(contact.contact_id)];
      } 
    })
    return {
      original: [...state.original],
      filtered: [...state.filtered],
    };
    case "ADD_CONTACT":
      return {
        filtered: [
          {
            ...action.payload,
            full_name:
              action.payload.first_name + " " + action.payload.last_name
          },
          ...state.filtered
        ],
        original: [
          {
            ...action.payload,
            full_name:
              action.payload.first_name + " " + action.payload.last_name
          },
          ...state.original
        ]
      };
    case "ADD_BULK_CONTACTS":
      return {
        filtered: action.payload
          .map(contact => {
            return {
              ...contact,
              full_name: contact.first_name + " " + contact.last_name
            };
          })
          .concat(state.filtered),
        original: action.payload
          .map(contact => {
            return {
              ...contact,
              full_name: contact.first_name + " " + contact.last_name
            };
          })
          .concat(state.original)
      };
    case "DELETE_CONTACT":
      return {
        filtered: state.filtered.filter(contact => {
          return contact.contact_id !== action.payload;
        }),
        original: state.original.filter(contact => {
          return contact.contact_id !== action.payload;
        })
      };
    case "BULK_DELETE_CONTACTS":
      return {
        filtered: state.filtered.filter(contact => {
          return !action.payload.includes(contact.contact_id);
        }),
        original: state.original.filter(contact => {
          return !action.payload.includes(contact.contact_id);
        })
      };
    default:
      return state;
  }
};

export const filterReducer = (state, action) => {
  switch (action.type) {
    case "SELECT_CONTACT_GROUP":
      return { ...state, selectedContactGroupId: action.payload };
    case "FILTER_SELECTED_CONTACTS":
      return { ...state, contactFilter: action.payload };
    default:
      return state;
  }
};

export const companyReducer = (state, action) => {
  switch (action.type) {
    case "SET_COMPANY":
      return action.payload;
    default:
      return state;
  }
};
export const connectionRequestCountReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONNECTION_REQUESTS_COUNT":
      return action.payload;
    default:
      return state;
  }
};
export const textQueryFilterReducer = (state, action) => {
  switch (action.type) {
    case "TEXT_QUERY_FILTER":
      return action.payload;
    default:
      return state;
  }
};

export const contactSelectionsReducer = (state, action) => {
  switch (action.type) {
    case "CONTACT_SELECTION":
      return action.payload;
    default:
      return state;
  }
};

export const connectionRequestsReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONNECTION_REQUESTS":
      return action.payload;
    default:
      return state;
  }
};

export const connectionsReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONNECTIONS":
      return action.payload;
    default:
      return state;
  }
}

export const contactsContextFetchStateReducer = (state, action) => {
  switch (action.type) {
    case "SET_FETCHING":
      return action.payload;
    default:
      return state;
  }
};

export const pageSizeReducer = (state, action) => {
  switch (action.type) {
    case "SET_PAGE_SIZE":
      return action.payload;
    default:
      return state;
  }
};
export const pageMapReducer = (state, action) => {
  switch (action.type) {
    case "SET_PAGE_MAP":
      let map = {
        ...state
      };
      map[action.page] = action.payload
      return map
    case "CLEAR_PAGE_MAP":
      return {};
    default:
      return state;
  }
};
export const pageReducer = (state, action) => {
  switch (action.type) {
    case "SET_PAGE":
      return action.payload;
    default:
      return state;
  }
};
export const paginationTokenReducer = (state, action) => {
  switch (action.type) {
    case "SET_PAGINATION_TOKEN":
      return action.payload;
    default:
      return state;
  }
};

export const columnsDisplayReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONNECTION_REQUEST_COLUMNS":
      return true;
    case "SET_CONTACT_COLUMNS":
      return false;
    default:
        return state;
  }
};
export const fetchContactsReducer = (state, action) => {
  switch (action.type) {
    case "FETCHING_CONTACTS":
      return true;
    case "FINISHED_CONTACTS":
        return false;
    default:
      return state;
  }
};



export const fetchContactListssReducer = (state, action) => {
  switch (action.type) {
    case "FETCHING_LISTS":
      return true;
    case "FINISHED_LISTS":
        return false;
    default:
      return state;
  }
};